class Leaseholder {
    id;
    name;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
    }
}
export default Leaseholder;
